import './styles.scss';

import { Badge, BadgeProps } from 'react-bootstrap';

import { getClasses } from '@/utils';

export type CardBubbleProps = BadgeProps & {
  children: React.ReactNode;
};

const CardBubble = ({ className, children, ...badgeProps }: CardBubbleProps): JSX.Element => (
  <Badge className={getClasses('CardBubble', className)} bg="light" text="dark" {...badgeProps}>
    {children}
  </Badge>
);

export default CardBubble;
